import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup } from './Forms';
import RevertableForm from './RevertableForm';
import { formatChangedLineValue } from '../utils/lines';

class LineForm extends RevertableForm {
  formatChangedValue(e) {
    return formatChangedLineValue(e);
  }

  render() {
    return (
      <div>
        <form className="card-body pt-0">
          <FormGroup
            control="textarea"
            name="text"
            label="Text"
            value={this.props.obj.text}
            onChange={this.handleChange}
            autosize
            rows={2}
            maxRows={8}
          />

          <div className="row">
            <div className="col-4">
              <div className="form-group">
                <FormGroup
                  type="number"
                  label="Syllables"
                  name="syllables"
                  value={this.props.obj.syllables || ''}
                  onChange={this.handleChange}
                />
              </div>
            </div>
            <div className="col-4">
              <FormGroup
                type="number"
                label="Stresses"
                name="stresses"
                value={this.props.obj.stresses || ''}
                onChange={this.handleChange}
              />
            </div>
          </div>
        </form>
        <div className="card-footer bg-white d-flex w-100 justify-content-between mt-2">
          {this.props.footerLeft}
          {this.props.footerCenter}
          {this.getRevertButton()}
        </div>
      </div>
    );
  }
}

LineForm.defaultProps = {
  ...RevertableForm.defaultProps,
  footer: undefined,
};
LineForm.propTypes = {
  ...RevertableForm.propTypes,
  footer: PropTypes.element,
};

export default LineForm;



// WEBPACK FOOTER //
// ./src/components/LineForm.js